import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Voice = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 20 20`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 3.125C10.75 2.71079 10.4142 2.375 10 2.375C9.58579 2.375 9.25 2.71079 9.25 3.125V16.875C9.25 17.2892 9.58579 17.625 10 17.625C10.4142 17.625 10.75 17.2892 10.75 16.875V3.125ZM5.6958 6.25C5.6958 5.83579 5.36001 5.5 4.9458 5.5C4.53159 5.5 4.1958 5.83579 4.1958 6.25V13.75C4.1958 14.1642 4.53159 14.5 4.9458 14.5C5.36001 14.5 5.6958 14.1642 5.6958 13.75V6.25ZM8.2229 7.5C8.2229 7.08579 7.88711 6.75 7.4729 6.75C7.05869 6.75 6.7229 7.08579 6.7229 7.5V12.5C6.7229 12.9142 7.05869 13.25 7.4729 13.25C7.88711 13.25 8.2229 12.9142 8.2229 12.5V7.5ZM2.4187 8.625C2.83291 8.625 3.1687 8.96079 3.1687 9.375V10.625C3.1687 11.0392 2.83291 11.375 2.4187 11.375C2.00449 11.375 1.6687 11.0392 1.6687 10.625V9.375C1.6687 8.96079 2.00449 8.625 2.4187 8.625ZM17.5813 8.625C17.9955 8.625 18.3313 8.96079 18.3313 9.375V10.625C18.3313 11.0392 17.9955 11.375 17.5813 11.375C17.1671 11.375 16.8313 11.0392 16.8313 10.625V9.375C16.8313 8.96079 17.1671 8.625 17.5813 8.625ZM12.5271 6.75C12.9413 6.75 13.2771 7.08579 13.2771 7.5V12.5C13.2771 12.9142 12.9413 13.25 12.5271 13.25C12.1129 13.25 11.7771 12.9142 11.7771 12.5V7.5C11.7771 7.08579 12.1129 6.75 12.5271 6.75ZM15.0542 5.5C15.4684 5.5 15.8042 5.83578 15.8042 6.25L15.8042 13.75C15.8042 14.1642 15.4684 14.5 15.0542 14.5C14.64 14.5 14.3042 14.1642 14.3042 13.75L14.3042 6.25C14.3042 5.83579 14.64 5.5 15.0542 5.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Voice
